import MyStore from './myStore'

export default MyStore